import styled from 'styled-components';

// TODO: TFR-44 move to container group
const Container = styled.div`
  padding: 4rem 0rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow:
    0px 8px 16px rgba(228, 230, 231, 0.25),
    0px 8px 32px rgba(236, 236, 236, 0.25);
`;

export default Container;
